/*
  RS Air Filter — consulta de frete (página do produto e carrinho).

  Só consulta: mostra valor e prazo, não grava nada.

  Por que assim:
  - A Shopify só cota frete para o carrinho da sessão (/cart/shipping_rates.json).
    Não existe endpoint que cote um produto solto, e a API de carrinho do
    Storefront não devolve tarifa de transportadora calculada, que é o caso
    da Frenet. Mesmo método do projeto Janaina Mello (md-pdp-frete).
  - Na página do produto: foto do carrinho, adiciona 1 unidade só se o
    produto ainda não estiver lá, cota e devolve o carrinho como estava.
  - O frete da Frenet é cotado pelo CEP. O estado é ignorado por ela, mas a
    Shopify recusa a cotação sem ele, então sai do próprio CEP por faixa
    oficial dos Correios. Medido em 14/09: mesmo CEP com PB, AC ou SP deu
    valores idênticos.
  - O valor muda com o produto e a quantidade (valor declarado), então não
    existe "estimativa genérica": sempre cotar o carrinho real.
*/
(function () {
  if (window.RSFrete) return;

  var FAIXAS = [
    [1000000, 19999999, 'São Paulo'],
    [20000000, 28999999, 'Rio de Janeiro'],
    [29000000, 29999999, 'Espírito Santo'],
    [30000000, 39999999, 'Minas Gerais'],
    [40000000, 48999999, 'Bahia'],
    [49000000, 49999999, 'Sergipe'],
    [50000000, 56999999, 'Pernambuco'],
    [57000000, 57999999, 'Alagoas'],
    [58000000, 58999999, 'Paraíba'],
    [59000000, 59999999, 'Rio Grande do Norte'],
    [60000000, 63999999, 'Ceará'],
    [64000000, 64999999, 'Piauí'],
    [65000000, 65999999, 'Maranhão'],
    [66000000, 68899999, 'Pará'],
    [68900000, 68999999, 'Amapá'],
    [69000000, 69299999, 'Amazonas'],
    [69300000, 69399999, 'Roraima'],
    [69400000, 69899999, 'Amazonas'],
    [69900000, 69999999, 'Acre'],
    [70000000, 72799999, 'Distrito Federal'],
    [72800000, 72999999, 'Goiás'],
    [73000000, 73699999, 'Distrito Federal'],
    [73700000, 76799999, 'Goiás'],
    [76800000, 76999999, 'Rondônia'],
    [77000000, 77999999, 'Tocantins'],
    [78000000, 78899999, 'Mato Grosso'],
    [79000000, 79999999, 'Mato Grosso do Sul'],
    [80000000, 87999999, 'Paraná'],
    [88000000, 89999999, 'Santa Catarina'],
    [90000000, 99999999, 'Rio Grande do Sul']
  ];

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function digitos(v) { return String(v || '').replace(/\D/g, '').slice(0, 8); }

  function estadoDoCep(d) {
    var n = parseInt(d, 10);
    for (var i = 0; i < FAIXAS.length; i++) {
      if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    }
    return null;
  }

  function escapa(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function moeda(valor, codigo) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: codigo || 'BRL' }).format(parseFloat(valor));
  }

  function prazo(r) {
    var d = r.delivery_days;
    if (d && d.length) {
      var min = d[0], max = d[d.length - 1];
      if (min === max) return min + (min === 1 ? ' dia útil' : ' dias úteis');
      return min + ' a ' + max + ' dias úteis';
    }
    return '';
  }

  function json(url, opcoes) {
    return fetch(url, opcoes).then(function (r) {
      return r.json()
        .then(function (corpo) { return { ok: r.ok, status: r.status, corpo: corpo }; })
        .catch(function () { return { ok: false, status: r.status, corpo: null }; });
    });
  }

  function mensagemErro(corpo) {
    if (corpo && typeof corpo === 'object') {
      var k = Object.keys(corpo)[0];
      if (k && Array.isArray(corpo[k]) && corpo[k][0]) return String(corpo[k][0]);
    }
    return 'Não foi possível calcular o frete para esse CEP.';
  }

  function cotarCarrinho(cep) {
    var d = digitos(cep);
    if (d.length !== 8) return Promise.resolve({ erro: 'Digite um CEP com 8 números.' });
    var uf = estadoDoCep(d);
    if (!uf) return Promise.resolve({ erro: 'Esse CEP não corresponde a nenhum estado. Confira os números.' });

    var url = raiz + 'cart/shipping_rates.json'
      + '?shipping_address%5Bzip%5D=' + encodeURIComponent(d)
      + '&shipping_address%5Bcountry%5D=Brazil'
      + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf);

    return json(url).then(function (res) {
      if (!res.ok) return { erro: mensagemErro(res.corpo) };
      var taxas = (res.corpo && res.corpo.shipping_rates) || [];
      if (!taxas.length) return { erro: 'Nenhuma transportadora atende esse CEP no momento. Fale com a gente pelo WhatsApp.' };
      taxas = taxas.slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
      return { taxas: taxas, uf: uf };
    }).catch(function () {
      return { erro: 'Não foi possível calcular agora. Tente de novo em instantes.' };
    });
  }

  async function cotarProduto(cep, variante) {
    var d = digitos(cep);
    if (d.length !== 8) return { erro: 'Digite um CEP com 8 números.' };
    if (!estadoDoCep(d)) return { erro: 'Esse CEP não corresponde a nenhum estado. Confira os números.' };
    if (!variante) return { erro: 'Não consegui identificar o produto. Recarregue a página.' };

    var chave = null;
    var tinhaOutros = false;
    try {
      var antes = await json(raiz + 'cart.js');
      var itens = (antes.corpo && antes.corpo.items) || [];
      var jaTinha = itens.some(function (i) { return i.id === variante; });
      tinhaOutros = itens.some(function (i) { return i.id !== variante; });

      if (!jaTinha) {
        var add = await json(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variante, quantity: 1 })
        });
        if (!add.ok) return { erro: mensagemErro(add.corpo) };
        // A chave da linha é o identificador que /cart/change.js aceita com certeza.
        chave = (add.corpo && add.corpo.key) || String(variante);
      }

      var r = await cotarCarrinho(d);
      r.tinhaOutros = tinhaOutros || jaTinha;
      return r;
    } catch (e) {
      return { erro: 'Não foi possível calcular agora. Tente de novo em instantes.' };
    } finally {
      if (chave) {
        await fetch(raiz + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: chave, quantity: 0 })
        }).catch(function () {});
      }
    }
  }

  function lista(taxas) {
    return '<ul class="rs-frete__opcoes">' + taxas.map(function (r) {
      var p = prazo(r);
      return '<li class="rs-frete__opcao">'
        + '<span class="rs-frete__nome">' + escapa(r.presentment_name || r.name) + '</span>'
        + (p ? '<span class="rs-frete__prazo">' + p + '</span>' : '')
        + '<span class="rs-frete__valor">' + moeda(r.price, r.currency) + '</span>'
        + '</li>';
    }).join('') + '</ul>';
  }

  function mascara(input) {
    var d = digitos(input.value);
    input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  window.RSFrete = {
    estadoDoCep: estadoDoCep,
    cotarCarrinho: cotarCarrinho,
    cotarProduto: cotarProduto,
    lista: lista,
    mascara: mascara,
    escapa: escapa
  };

  /* ---- Carrinho (gaveta e página /cart) ----
     Delegação no document: a gaveta é redesenhada a cada mudança do carrinho
     e perderia ouvintes presos ao elemento. Sem <form>, com botão comum,
     para não correr risco de enviar o formulário do carrinho. */
  function alvoCarrinho(el) { return el && el.closest ? el.closest('[data-rs-frete-carrinho]') : null; }

  async function calcularCarrinho(caixa) {
    var campo = caixa.querySelector('[data-rs-frete-cep]');
    var botao = caixa.querySelector('[data-rs-frete-calcular]');
    var saida = caixa.querySelector('[data-rs-frete-saida]');
    if (!campo || !saida || caixa.dataset.ocupado === '1') return;

    caixa.dataset.ocupado = '1';
    if (botao) { botao.disabled = true; botao.dataset.rotulo = botao.textContent; botao.textContent = 'Calculando'; }
    saida.hidden = false;
    saida.className = 'rs-frete__saida';
    saida.innerHTML = '<p class="rs-frete__aguarde">Consultando as transportadoras…</p>';

    var r = await cotarCarrinho(campo.value);
    if (r.erro) {
      saida.className = 'rs-frete__saida is-erro';
      saida.innerHTML = '<p>' + escapa(r.erro) + '</p>';
    } else {
      saida.innerHTML = lista(r.taxas)
        + '<p class="rs-frete__nota">Valores para o seu carrinho, entrega em ' + escapa(r.uf) + '. O valor final é confirmado no checkout.</p>';
    }

    caixa.dataset.ocupado = '';
    if (botao) { botao.disabled = false; botao.textContent = botao.dataset.rotulo || 'Calcular'; }
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-rs-frete-cep]')) mascara(e.target);
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-rs-frete-calcular]') : null;
    var caixa = alvoCarrinho(b);
    if (caixa) { e.preventDefault(); calcularCarrinho(caixa); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches('[data-rs-frete-cep]')) return;
    var caixa = alvoCarrinho(e.target);
    if (caixa) { e.preventDefault(); calcularCarrinho(caixa); }
  });
})();
